import type React from 'react';
import { styled } from 'styled-components';

import Td from './Td.tsx';
import Tr from './Tr.tsx';

const Info = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey70_1};
  text-align: center;
`;

export interface ITableInfo extends React.PropsWithChildren {
  dataTestId?: string;
}

const TableInfo: React.FC<ITableInfo> = ({ children, dataTestId }) => (
  <tbody>
    <Tr>
      <Td type='sub' padding='14px' bgColor='transparent'>
        <Info data-testid={dataTestId}>{children}</Info>
      </Td>
    </Tr>
  </tbody>
);

export default TableInfo;
